module.exports = __webpack_public_path__ + "images/resize_cert_input.svg";